import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGaugeIncomplete = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 400,
	height: 233,
	viewBox: "0 0 400 233",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			opacity: .3,
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M102.7 184.4H53C53 174.3 54 164.3 56 154.5C58 145 60.9 135.6 64.7 126.6C68.4 117.8 73.1 109.3 78.4 101.4C83.7 93.5 89.9 86.2 96.6 79.4C103.3 72.7 110.8 66.6 118.7 61.3C126.7 55.9 135.2 51.3 144 47.6C153 43.8 162.4 40.9 172 39C181.8 37 191.9 36 202 36C212 36 222.1 37 231.8 39C241.3 40.9 250.6 43.8 259.6 47.5C268.4 51.2 276.8 55.7 284.8 61C292.7 66.2 300 72.2 306.8 78.9L271 113.2C266.5 108.9 261.6 105 256.5 101.6C251.3 98.2 245.7 95.3 239.9 92.9C234 90.5 227.9 88.6 221.7 87.4C215.3 86.1 208.7 85.5 202.2 85.5C195.5 85.5 188.7 86.2 182.2 87.5C175.8 88.8 169.5 90.7 163.6 93.3C157.7 95.8 152 98.8 146.7 102.4C141.4 105.9 136.5 110 132 114.5C127.5 119 123.4 123.9 119.9 129.1C116.3 134.4 113.2 140 110.7 145.9C108.2 151.9 106.2 158.1 104.9 164.5C103.4 171 102.7 177.7 102.7 184.4ZM351 184.4H301.3C301.3 177.8 300.7 171.3 299.4 164.9C298.2 158.7 296.3 152.6 293.9 146.7C291.5 141 288.6 135.4 285.2 130.2C281.8 125 277.9 120.2 273.6 115.7L309.8 81.8C316.2 88.5 322 95.8 327 103.5C332.1 111.3 336.5 119.6 340 128.2C343.6 136.9 346.4 146.1 348.2 155.3C350 164.9 351 174.6 351 184.4Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .5,
			d: "M93.5 82L128 118.5C124.3 122.4 122.7 124.6 119.6 129.1C116 134.4 112.9 140 110.4 145.9C107.9 151.9 105.9 158.1 104.6 164.5C103.3 171 102.6 177.7 102.6 184.4H53C53 174.3 54 164.3 56 154.5C58 145 60.9 135.6 64.7 126.6C68.4 117.8 73.1 109.3 78.4 101.4C83.4 94.1 87.3 88.3 93.5 82Z",
			fill: "url(#paint0_linear_93_21776)"
		}),
		/* @__PURE__ */ _jsx("g", {
			opacity: .4,
			children: /* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M305.8 184.4H96.2998C96.2998 177.3 96.9998 170.2 98.3998 163.4C99.7998 156.7 101.8 150.1 104.5 143.8C107.1 137.6 110.4 131.7 114.2 126.1C117.9 120.6 122.3 115.4 127 110.7C131.7 106 137 101.7 142.5 98C148.1 94.2 154.1 91 160.3 88.4C166.6 85.7 173.2 83.7 180 82.3C186.9 80.9 194 80.2 201.1 80.2C208.2 80.2 215.3 80.9 222.2 82.3C228.9 83.7 235.5 85.7 241.9 88.4C248.1 91 254.1 94.3 259.7 98C265.2 101.7 270.5 106 275.2 110.7C279.9 115.4 284.2 120.6 288 126.1C291.8 131.7 295 137.6 297.7 143.8C300.4 150.1 302.4 156.7 303.8 163.4C305.1 170.2 305.8 177.3 305.8 184.4Z",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .8,
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M191 186.3L190.6 186C190.5 185.9 190.3 185.8 190.2 185.6C189.9 185.3 189.7 185.1 189.5 184.8L91.5 79.7L93.4 77.5L200.3 173.5C200.7 173.8 201 174.1 201.4 174.4C201.5 174.5 201.7 174.7 201.8 174.8L202.1 175.1C204.5 178.2 204.3 182.7 201.4 185.5C199.9 187 197.8 187.8 195.8 187.8C194.2 188 192.5 187.4 191 186.3Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_93_21776",
			x1: 90.5,
			y1: 80.8946,
			x2: 90.5,
			y2: 184.401,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopOpacity: .8 }), /* @__PURE__ */ _jsx("stop", { offset: 1 })]
		}) })
	]
});
export default SvgGaugeIncomplete;
